type ValidatorOptions = {
  required?: string
  maxLength?: { value: number; message: string }
  validate?: Record<string, (v: unknown) => true | string>
}

type Validator = (label: string) => ValidatorOptions

export const compose =
  (...validators: Validator[]): Validator =>
  label => {
    const options: ValidatorOptions = {}
    for (const validator of validators) {
      const { validate, ...rest } = validator(label)
      Object.assign(options, rest)
      if (validate) {
        options.validate = { ...options.validate, ...validate }
      }
    }
    return options
  }

export const validateRequired: Validator = label => ({
  required: `${label}を入力してください。`,
})

export const validateMaxLength =
  (max: number): Validator =>
  label => ({
    maxLength: {
      value: max,
      message: `${label}は${max}文字以内で入力してください。`,
    },
  })

export const validateEmailPattern: Validator = label => ({
  validate: {
    emailPattern: (v: unknown) => {
      if (typeof v !== 'string') return true
      if (!/^[a-zA-Z0-9!?@#$&+\-*_.,]+$/.test(v)) {
        return `${label}は半角英数字記号で入力してください。`
      }
      return (
        /^[^@\s]+@([^@\s]+\.)+[^@\s]+$/.test(v) ||
        '入力したメールアドレスが間違っています。正しいメールアドレスを入力してください。'
      )
    },
  },
})

export const validatePinCodePattern: Validator = label => ({
  validate: {
    pinCodePattern: (v: unknown) => {
      if (typeof v !== 'string' || v.length !== 6) {
        return `${label}を入力してください。`
      }
      if (!/^\d*$/.test(v)) {
        return `${label}は数字で入力してください。`
      }
      return true
    },
  },
})

export const validatePasswordPattern: Validator = label => ({
  validate: {
    passwordPattern: (v: unknown) =>
      (typeof v === 'string' &&
        /^(?=.*[A-Za-z!@#$&*_])(?=.*[0-9])[A-Za-z0-9!@#$&*_]{8,256}$/.test(v)) ||
      `${label}は数字、英字を1文字以上含む、8文字以上の半角英数字記号で入力してください。`,
  },
})
